<template>
	<div class="webContent flex df cf">
		<div class="detail">
			<div class="title"><i :class="type"></i>{{title}}</div>
			<div class="txt" v-html="txt">{{txt}}</div>
			<div class="tool df hao">
				<div class="download">{{downloadCount}}次下载</div>
				<div class="collect">{{collectCount}}人收藏</div>
				<div class="flex"></div>
				<div class="date">{{date}}</div>
				<div class="user">{{user}}</div>
			</div>
		</div>
		<div class="end df war hao">
			<div class="downloadBtn">下载</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'material_detail_page',
		data () {
			return {
				title: '911启动说明书',
				type: 'pdf',
				txt: '一般都是自动收起的、和软顶的一样、也有个别的不是、是需要自己拆下来的、比如保时捷卡雷拉GT、柯尼塞格、帕加尼、这些是自己拆下来的。<br><br><img style="display: block; max-width: 100%; margin: 0.08rem auto;" src="'+require('@/app/assets/temp/16.jpg')+'" /><img style="display: block; max-width: 100%; margin: 0.08rem auto;" src="'+require('@/app/assets/temp/17.jpg')+'" />您可以在特定于市场的家用电源插座以及工业电源插座上给您的保时捷爱车充电。 为了能够通过可能最高的效率和可能最短的充电时长进行充电，我们建议使用工业电源插座。<img style="display: block; max-width: 100%; margin: 0.08rem auto;" src="'+require('@/app/assets/temp/18.jpg')+'" />',
				date: '2020-11-15',
				user: '李玉雨',
				downloadCount: 133,
				collectCount: 15,
			}
		},
		methods: {
		},
	}
</script>

<style scoped>
	@import './detail'
</style>



// WEBPACK FOOTER //
// src/app/pages/material/detail/detail.vue